<template>
  <div class="container">
    <div class="product-header">
      <div class="ph-tit">让收银变得更简单</div>
      <div class="ph-tip">为解决自助收银场景而研发的一款收银系统</div>
      <div class="ph-btn" @click.stop="clickdownloadBySelf">立即下载</div>
    </div>
    <div class="product-introduce">
      <div class="pi-left">
        <div class="pi-le-tit">无人自助新体验</div>
        <div class="pi-le-tip">
          丰派自助收银视觉效果美观，功能设计完善，收银操作简单，可以给顾客带来更流畅、更简便的自助体验
        </div>
        <div class="pi-le-row">
          <div class="row-item">
            <div class="row-top">
              <img
                src="@/assets/newdownload/prow3.png"
                alt=""
                class="row-icon"
              />
              <span class="row-word">高效率</span>
            </div>
            <div class="row-bottom">减少收银等待时间</div>
          </div>
          <div class="row-item">
            <div class="row-top">
              <img
                src="@/assets/newdownload/prow1.png"
                alt=""
                class="row-icon"
              />
              <span class="row-word">好体验</span>
            </div>
            <div class="row-bottom">安全识别，秒速支付</div>
          </div>
        </div>
        <div class="pi-le-row">
          <div class="row-item">
            <div class="row-top">
              <img
                src="@/assets/newdownload/prow4.png"
                alt=""
                class="row-icon"
              />
              <span class="row-word">降成本、省人力</span>
            </div>
            <div class="row-bottom">节省30%收银台部署、收银人工</div>
          </div>
          <div class="row-item">
            <div class="row-top">
              <img
                src="@/assets/newdownload/prow2.png"
                alt=""
                class="row-icon"
              />
              <span class="row-word">易安装</span>
            </div>
            <div class="row-bottom">兼容横屏竖屏，无需店铺改造</div>
          </div>
        </div>
        <div class="like"></div>
      </div>
      <img class="pi-right" v-lazy="require('@/assets/newdownload/pint.png')" alt="" />
    </div>
    <div class="product-process">
      <div class="pp-content">
        <div class="pc-tit">自助购流程</div>
        <div class="pc-tip">界面功能清晰易懂，操作简单，一秒上手</div>
        <div class="pc-process">
          <div class="pc-p-item">
            <div class="p-num">
              <span class="num">1</span>会员登录<span class="line"></span>
            </div>
            <div class="p-tip">会员可先进行登录</div>
            <img
              src="@/assets/newdownload/pprocess1.png"
              alt=""
              class="p-img"
            />
          </div>
          <div class="pc-p-item">
            <div class="p-num">
              <span class="num">2</span>扫描商品条码<span class="line"></span>
            </div>
            <div class="p-tip">将商品条码对准扫描口进行扫描</div>
            <img
              src="@/assets/newdownload/pprocess2.png"
              alt=""
              class="p-img"
            />
          </div>
          <div class="pc-p-item">
            <div class="p-num">
              <span class="num">3</span>结算<span class="line"></span>
            </div>
            <div class="p-tip">用户自行选择付款方式进行付款</div>
            <img
              src="@/assets/newdownload/pprocess3.png"
              alt=""
              class="p-img"
            />
          </div>
          <div class="pc-p-item">
            <div class="p-num"><span class="num">4</span>取走商品、小票</div>
            <div class="p-tip">付款成功后等待小票打印</div>
            <img
              src="@/assets/newdownload/pprocess4.png"
              alt=""
              class="p-img"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="product-payway">
      <div class="pp-content">
        <div class="pc-tit">多种付款方式选择</div>
        <div class="pc-tip">支付简单快捷，无需担心支付问题</div>
        <div class="pc-list">
          <div class="pl-item">
            <img
              src="@/assets/newdownload/payway1.png"
              alt=""
              class="item-img"
            />
            <div class="item-word">微信刷脸</div>
          </div>
          <div class="pl-item">
            <img
              src="@/assets/newdownload/payway2.png"
              alt=""
              class="item-img"
            />
            <div class="item-word">付款码支付</div>
          </div>
          <div class="pl-item">
            <img
              src="@/assets/newdownload/payway3.png"
              alt=""
              class="item-img"
            />
            <div class="item-word">余额支付</div>
          </div>
          <div class="pl-item">
            <img
              src="@/assets/newdownload/payway4.png"
              alt=""
              class="item-img"
            />
            <div class="item-word">扫码支付</div>
          </div>
        </div>
      </div>
    </div>
    <div class="product-system">
      <div class="ps-content">
        <div class="psc-left">
          <div class="pscl-tit">虽少但精的系统配置</div>
          <div class="pscl-tip">
            丰派自助收银配备语音提示、一键同步商品等功能，满足商家基本需求。
          </div>
          <img v-lazy="require('@/assets/newdownload/pscl.png')" alt="" class="pscl-img" />
        </div>
        <div class="psc-right">
          <div class="psc-right-row">
            <div class="pscr-item">
              <div class="item-tit">小票设置</div>
              <div class="item-tip">
                商家可自行设置是否打印小票、打印数量、尺寸。
              </div>
              <img
                src="@/assets/newdownload/pssytem1.png"
                alt=""
                class="item-img"
              />
            </div>
            <div class="pscr-item">
              <div class="item-tit">刷脸支付设置</div>
              <div class="item-tip">
                商家可自行设置是否开启微信刷脸支付功能。
              </div>
              <img
                src="@/assets/newdownload/pssytem2.png"
                alt=""
                class="item-img"
              />
            </div>
          </div>
          <div class="psc-right-row" style="margin-top: 20px">
            <div class="pscr-item">
              <div class="item-tit">语音播报设置</div>
              <div class="item-tip">
                商家可自行设置是否打开启语音播报，以及设置语音播报的内容。
              </div>
              <img
                src="@/assets/newdownload/pssytem3.png"
                alt=""
                class="item-img"
              />
            </div>
            <div class="pscr-item">
              <div class="item-tit">一键同步数据</div>
              <div class="item-tip">
                丰派自助收银配备一键同步数据功能，商家无需逐一导入商品数据。
              </div>
              <img
                src="@/assets/newdownload/pssytem4.png"
                alt=""
                class="item-img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "webproduct",
  data() {
    return {
      // swiperOption6: {
      //   loop: true,
      //   // loopAdditionalSlides: 6,
      //   autoplay: {
      //     delay: 3000,
      //     // stopOnLastSlide: false,
      //     disableOnInteraction: false,
      //   },
      // },
      // featureList: [
      //   {
      //     id: 1,
      //     img: require("@/assets/system1.png"),
      //     tit: "全新界面",
      //     tip: "界面全新升级，操作简单，用户可以快速上手，",
      //     tip1: "告别繁杂的培训学习",
      //   },
      //   {
      //     id: 2,
      //     img: require("@/assets/system2.png"),
      //     tit: "一体化营销",
      //     tip: "公众号、小程序、微信群、企业微信互联互通，",
      //     tip1: "流量变现快速高效，促销多样化",
      //   },
      //   {
      //     id: 3,
      //     img: require("@/assets/system3.png"),
      //     tit: "开放式API对接",
      //     tip: "开放式API支持打通各大会员系统、供应链、",
      //     tip1: "WMS系统、TMS系统等",
      //   },
      //   {
      //     id: 4,
      //     img: require("@/assets/system4.png"),
      //     tit: "全新框架",
      //     tip: "云技术高性能框架搭建的收银系统，性能稳定，",
      //     tip1: "简单易用，各机构数据实时同步",
      //   },
      //   {
      //     id: 5,
      //     img: require("@/assets/system5.png"),
      //     tit: "云端同步",
      //     tip: "采用全新同步技术和增加本地缓存库，遇到断网",
      //     tip1: "等突发情况开启自动保护机制",
      //   },
      //   {
      //     id: 6,
      //     img: require("@/assets/system6.png"),
      //     tit: "硬件无忧",
      //     tip: "兼容Windows、苹果IOS、安卓，不管使用什么",
      //     tip1: "设备，都有对应的客户端为您快速提升效率",
      //   },
      // ],
    };
  },
  methods: {
    go() {
      location.href = "https://www.xyjpos.com/fpPos/#/login";
    },
    clickdownloadBySelf() {
      let elink = document.createElement("a");
      elink.download = "自助收银版本下载";
      elink.style.display = "none";
      elink.href = "https://www.ld8848.cn/fp_pos_auto/fp_pos_auto.apk";
      elink.target = "_self";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
  },
  activated() {
    // this.$nextTick(() => {
    //   this.$wow.init();
    // });
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  min-width: 1420px;
  background: #fff;
  position: relative;
  top: 64px;
}
.mixin-word() {
  font-family: "Noto Sans SC";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
}
.product-header {
  width: 100%;
  height: 560px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url("~@/assets/newdownload/productbg.png");
  .ph-tit {
    .mixin-word;
    font-weight: 500;
    font-size: 72px;
    line-height: 104px;
    color: #1f2329;
  }
  .ph-tip {
    margin-top: 10px;
    font-size: 32px;
    line-height: 46px;
    text-align: center;
    letter-spacing: 0.18em;
    color: #1f2329;
  }
  .ph-btn {
    margin-top: 54px;
    width: 224px;
    height: 54px;
    background: #336fff;
    box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
    border-radius: 6px;
    .mixin-word;
    font-size: 20px;
    line-height: 54px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
    &:hover {
      background: #5c8cff;
      box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
    }
  }
}
.product-introduce {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 580px;
  background: #ffffff;
  .pi-right {
    margin-left: 60px;
    width: 580px;
    height: 460px;
  }
  .pi-left {
    width: 584px;
    // height: 332px;
    .pi-le-tit {
      .mixin-word;
      font-size: 40px;
      line-height: 56px;
      color: #292929;
    }
    .pi-le-tip {
      margin-top: 40px;
      .mixin-word;
      font-size: 18px;
      line-height: 26px;
      color: #2d3c50;
    }
    .pi-le-row {
      margin-top: 40px;
      // width: 280px;
      height: 52px;
      display: flex;
      align-items: center;
      .row-item {
        flex: 1;
      }
      .row-item + .row-item {
        margin-left: 24px;
      }
      .row-top {
        display: flex;
        align-items: center;
        // justify-content: center;
        .row-icon {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
        .row-word {
          .mixin-word;
          font-size: 16px;
          line-height: 24px;
          color: #455770;
        }
      }
      .row-bottom {
        margin-left: 30px;
        .mixin-word;
        font-size: 16px;
        line-height: 24px;
        color: #455770;
      }
    }
  }
}
.product-process {
  width: 100%;
  height: 786px;
  background: #ffffff;
  display: flex;
  // align-items: center;
  justify-content: center;
  .pp-content {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .pc-tit {
      margin-top: 40px;
      .mixin-word;
      font-size: 40px;
      line-height: 48px;
      color: #1f2329;
    }
    .pc-tip {
      margin-top: 16px;
      .mixin-word;
      font-size: 18px;
      line-height: 26px;
      color: #51565d;
    }
    .pc-process {
      margin-top: 44px;
      display: flex;
      align-items: center;
      .pc-p-item {
        width: 285px;
        .p-num {
          .mixin-word;
          font-size: 18px;
          line-height: 26px;
          color: #292929;
          display: flex;
          align-items: center;
          .num {
            display: inline-block;
            width: 32px;
            height: 32px;
            background: #336fff;
            border-radius: 32px;
            line-height: 32px;
            color: #ffffff;
            text-align: center;
            margin-right: 8px;
          }
          .line {
            margin-left: 16px;
            display: inline-block;
            // width: 157px;
            flex: 1;
            height: 0px;
            border: 1px solid #c0c4cc;
          }
        }
        .p-tip {
          margin-top: 3px;
          margin-left: 40px;
          font-size: 16px;
          line-height: 24px;
          color: rgba(0, 0, 0, 0.85);
        }
        .p-img {
          margin-left: 20px;
          // width: 225px;
          height: 400px;
          border-radius: 6px;
        }
      }
      .pc-p-item + .pc-p-item {
        margin-left: 20px;
      }
    }
    .pc-imglist {
      margin-top: 20px;
      display: flex;
      .p-img-item {
        width: 225px;
        // height: 400px;
        border-radius: 6px;
        filter: drop-shadow(9px 12px 34px rgba(112, 114, 138, 0.1));
      }
      .p-img-item + .p-img-item {
        margin-left: 80px;
      }
    }
  }
}
.product-payway {
  width: 100%;
  height: 524px;
  display: flex;
  // align-items: center;
  justify-content: center;
  .pp-content {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .pc-tit {
      margin-top: 40px;
      .mixin-word;
      font-size: 40px;
      line-height: 48px;
      color: #1f2329;
    }
    .pc-tip {
      margin-top: 16px;
      .mixin-word;
      font-size: 18px;
      line-height: 26px;
      color: #51565d;
    }
    .pc-list {
      margin-top: 56px;
      display: flex;
      align-items: center;
      .pl-item {
        width: 272px;
        height: 298px;
        .item-img {
          width: 272px;
          height: 272px;
        }
        .item-word {
          .mixin-word;
          font-size: 18px;
          line-height: 26px;
          color: #51565d;
          text-align: center;
        }
      }
      .pl-item + .pl-item {
        margin-left: 37px;
      }
    }
  }
}
.product-system {
  width: 100%;
  height: 640px;
  display: flex;
  background: url("~@/assets/newdownload/productsys.png");
  justify-content: center;
  .ps-content {
    margin-top: 100px;
    width: 1200px;
    display: flex;
    .psc-left {
      width: 440px;
      .pscl-tit {
        .mixin-word;
        font-size: 40px;
        line-height: 56px;
      }
      .pscl-tip {
        margin-top: 24px;
        .mixin-word;
        font-size: 18px;
        line-height: 26px;
        color: #6c727b;
      }
      .pscl-img {
        margin-top: 24px;
        width: 307.65px;
        height: 280px;
      }
    }
    .psc-right {
      margin-left: 100px;
      gap: 20px;
      width: 660px;
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // flex-wrap: wrap;
      .psc-right-row {
        display: flex;
        gap: 20px;
      }
      .pscr-item {
        flex-shrink: 0;
        width: 320px;
        height: 206px;
        border: 1px solid #2d3c50;
        border-radius: 8px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        .item-tit {
          .mixin-word;
          font-size: 20px;
          line-height: 28px;
          color: #292929;
        }
        .item-tip {
          margin-top: 16px;
          .mixin-word;
          font-size: 15px;
          line-height: 24px;
          color: #596069;
        }
        .item-img {
          align-self: flex-end;
          margin-top: 10px;
          width: 56px;
          height: 56px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/productauto.vue